<div>
    <h1>Tags</h1>
    <p>Here you can Edit and Merge tags</p>
    <div align="end">
        <button mat-stroked-button [matMenuTriggerFor]="menu">
            Actions
            <mat-icon>expand_more</mat-icon>
        </button>
        <mat-menu #menu="matMenu">
            <button
                mat-menu-item
                [disabled]="selection.selected.length === 0"
                (click)="mergeTags(selection.selected)"
            >
                <mat-icon>merge_type</mat-icon> Merge Selected
            </button>
            <button
                mat-menu-item
                [disabled]="selection.selected.length === 0"
                (click)="removeTags(selection.selected)"
            >
                <mat-icon>delete</mat-icon> Remove Selected
            </button>
        </mat-menu>
    </div>
</div>

<form [formGroup]="form">
    <mat-form-field>
        <mat-label>Filter</mat-label>
        <input matInput formControlName="query" #input />
        @if (input.value) {
            <button mat-button matSuffix mat-icon-button aria-label="Clear" (click)="clearFilter()">
                <mat-icon>close</mat-icon>
            </button>
        }
    </mat-form-field>

    <mat-checkbox formControlName="unusedOnly">Unused Only</mat-checkbox>
</form>

@if (error) {
    <div>
        {{ error }}
    </div>
}

<div class="mat-elevation-z8">
    @if (isLoadingResults) {
        <div class="example-loading-shade">
            @if (isLoadingResults) {
                <mat-spinner></mat-spinner>
            }
        </div>
    }

    <div>
        <table
            mat-table
            [dataSource]="dataSource"
            matSort
            matSortActive="created"
            matSortDisableClear
            matSortDirection="desc"
        >
            <ng-container matColumnDef="select">
                <th mat-header-cell *matHeaderCellDef>
                    <mat-checkbox
                        (change)="$event ? masterToggle() : null"
                        [checked]="selection.hasValue() && isAllSelected()"
                        [indeterminate]="selection.hasValue() && !isAllSelected()"
                    >
                    </mat-checkbox>
                </th>
                <td mat-cell *matCellDef="let row">
                    <mat-checkbox
                        (click)="$event.stopPropagation()"
                        (change)="$event ? selection.toggle(row) : null"
                        [checked]="selection.isSelected(row)"
                    >
                    </mat-checkbox>
                </td>
            </ng-container>

            <ng-container matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Name</th>
                <td mat-cell *matCellDef="let row">
                    {{ row.displayName }}
                </td>
            </ng-container>
            <ng-container matColumnDef="category">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Category</th>
                <td mat-cell *matCellDef="let row">
                    {{ row.category }}
                </td>
            </ng-container>
            <ng-container matColumnDef="count">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Count</th>
                <td mat-cell *matCellDef="let row">
                    {{ row.count }}
                </td>
            </ng-container>
            <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef mat-sort-header></th>
                <td mat-cell *matCellDef="let row">
                    <button mat-icon-button [matMenuTriggerFor]="menu">
                        <mat-icon>more_horiz</mat-icon>
                    </button>
                    <mat-menu #menu="matMenu">
                        <button mat-menu-item (click)="editTag(row)">Edit</button>
                        <mat-divider></mat-divider>
                        <button mat-menu-item (click)="removeTags([row])">Remove</button>
                    </mat-menu>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        </table>
    </div>

    <mat-paginator [length]="resultsLength" [pageSize]="50"></mat-paginator>
</div>
